import React from "react";
import "./View_Booking_Modal.css";
import { Button, Form, Modal } from "react-bootstrap";

function View_Booking_Modal({ ...props }) {
  console.log("Booking Details:", props?.bookingdetails);

  return (
    <>
      <section className="View_Modal_holder">
        <Modal
          {...props}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          className="View_Modal"
        >
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter">
              Booking Details
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="form_holder">
              <div>
                {/* Title between objects */}
                <div className="row">
                  {props?.type == "Cab" ? (
                    ""
                  ) : (
                    <div className="col-md-6">
                      <b>Sender Name : </b>
                      <p>{props?.bookingdetails?.sender_name || "-"}</p>
                    </div>
                  )}

                  {props?.type == "Cab" ? (
                    ""
                  ) : (
                    <div className="col-md-6">
                      <b>Sender Contact No. : </b>
                      <p>{props?.bookingdetails?.sender_contact_no || "-"}</p>
                    </div>
                  )}
                  <div className="col-md-6">
                    <b>Pickup Address : </b>
                    <p>{props?.bookingdetails?.pickup_address || "-"}</p>
                  </div>
                  <div className="col-md-3">
                    <b>Pickup latitude : </b>
                    <p>{props?.bookingdetails?.pickup_lat || "-"}</p>
                  </div>
                  <div className="col-md-3">
                    <b>Pickup longitude : </b>
                    <p>{props?.bookingdetails?.pickup_long || "-"}</p>
                  </div>
                  <div className="col-md-3">
                    <b>Distance : </b>
                    <p>{props?.bookingdetails?.distance || "-"}</p>
                  </div>
                  <div className="col-md-3">
                    <b>Vehicle Category : </b>
                    <p>
                      {props?.bookingdetails?.Vehicle_Category?.name || "-"}
                    </p>
                  </div>
                  <div className="col-md-3">
                    <b>Vehicle : </b>
                    <p>{props?.bookingdetails?.Vehicle?.name || "-"}</p>
                  </div>
                  {props?.type == "Cab" ? (
                    ""
                  ) : (
                    <div className="col-md-3">
                      <b>Good Type : </b>
                      <p>{props?.bookingdetails?.Good_Type?.name || "-"}</p>
                    </div>
                  )}
                  <div className="col-md-3">
                    <b>Booking Status : </b>
                    <p>{props?.bookingdetails?.BookingStatus?.name || "-"}</p>
                  </div>
                  {props?.type == "Cab" ? (
                    ""
                  ) : (
                    <div className="col-md-3">
                      <b>Luggage Type : </b>
                      <p>{props?.bookingdetails?.LuggageType?.name || "-"}</p>
                    </div>
                  )}
                </div>
                <hr /> {/* Optional separator between objects */}
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </section>
    </>
  );
}

export default View_Booking_Modal;
